export enum SimpleSortAction {
    Asc = "Asc",
    Desc = "Desc"
}